import { render, staticRenderFns } from "./OrganosCorporativos.vue?vue&type=template&id=2f62f90e&scoped=true"
import script from "./OrganosCorporativos.vue?vue&type=script&lang=js"
export * from "./OrganosCorporativos.vue?vue&type=script&lang=js"
import style0 from "./OrganosCorporativos.vue?vue&type=style&index=0&id=2f62f90e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62f90e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f62f90e')) {
      api.createRecord('2f62f90e', component.options)
    } else {
      api.reload('2f62f90e', component.options)
    }
    module.hot.accept("./OrganosCorporativos.vue?vue&type=template&id=2f62f90e&scoped=true", function () {
      api.rerender('2f62f90e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/OrganosCorporativos.vue"
export default component.exports